import { render, staticRenderFns } from "./SharedSwiper.vue?vue&type=template&id=7472a746&scoped=true&"
import script from "./SharedSwiper.vue?vue&type=script&lang=ts&"
export * from "./SharedSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./SharedSwiper.vue?vue&type=style&index=0&id=7472a746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7472a746",
  null
  
)

export default component.exports